import { combineReducers } from 'redux';
import Auth from './Auth';
import User from './Users';
import Theme from './Theme';
import Gateway from './Gateway';
import Language from './GlobalLanguages';
import AppControl from './AppControls';
import SocialLinks from './SocialLinks';
import FCMCredentials from './FCMCredentials';
import SMTPCredentials from './SMTPCredentials';
import Admins from './Admins';
import AppDiscount from './AppDiscount';
import Filter from './Filter';

const reducers = combineReducers({
    filter: Filter,
    theme: Theme,
    auth: Auth,
    user: User,
    gateway: Gateway,
    language: Language,
    appControl: AppControl,
    socialLinks: SocialLinks,
    FCMCredentials: FCMCredentials,
    SMTPCredentials: SMTPCredentials,
    Admins: Admins,
    AppDiscount: AppDiscount,
});

export default reducers;